/** 3D 资源是否已加载完毕并完成加载页的离场等待。 */
import { atom, useRecoilState } from 'recoil';

const preloaderReadyState = atom<boolean>({
    key: 'preloaderReadyState',
    default: false,
});

export const usePreloaderReadyState = () => useRecoilState(preloaderReadyState);
